import { render, staticRenderFns } from "./FeedContentComments.vue?vue&type=template&id=5f785d2a&scoped=true&"
import script from "./FeedContentComments.vue?vue&type=script&lang=ts&"
export * from "./FeedContentComments.vue?vue&type=script&lang=ts&"
import style0 from "./FeedContentComments.vue?vue&type=style&index=0&id=5f785d2a&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f785d2a",
  null
  
)

export default component.exports